// seleccionDelLienzo.ts — lo seleccionado en el lienzo aparece en la caja del chat como
// adjuntos TENTATIVOS: apagados, sin X, y pasan a adjuntos de verdad cuando el usuario
// escribe (ADR-2026-09-24-la-seleccion-del-lienzo-se-adjunta-al-escribir). Pura a
// propósito: el contexto del chat la llama con lo que tiene.

import type { ChatAttachment } from '../pages/v2/agentAttachments';

/** Qué informa el lienzo de su selección: los ids de las celdas (para el `describir` de la
 *  pantalla) y el chip de cada una (lo mismo que arma "Agregar al chat"). */
export interface SeleccionDelLienzo {
  ids: string[];
  chips: ChatAttachment[];
}

export const SIN_SELECCION: SeleccionDelLienzo = { ids: [], chips: [] };

/**
 * Las tentativas: lo seleccionado que no está ya en la caja ni fue sacado con la X
 * (`descartadas`, que se olvida cuando cambia la selección: si no, una foto sacada
 * volvía apagada al instante).
 */
export function tentativasDeSeleccion(
  seleccion: readonly ChatAttachment[],
  adjuntos: readonly ChatAttachment[],
  descartadas: ReadonlySet<string>,
): ChatAttachment[] {
  const enLaCaja = new Set(adjuntos.map((a) => a.id));
  return seleccion.filter((a) => !enLaCaja.has(a.id) && !descartadas.has(a.id));
}
